// extracted by mini-css-extract-plugin
export default {"chip":"CategoryChip_chip__zu+gv","active":"CategoryChip_active__jiMt4"};